import styled from '@emotion/styled';
import Image from 'next/image';
import JobCardList from '../JobCard/list';
import { primary, gray, white } from '@styles/Colors';
import { useRouter } from 'next/router';
import { COMPANY_HIRE_NOTION, COMPANY_HIRE_NOTION_LIST } from '@constants/routes/routes';
import SummaryTextList from '../SummaryTextList';
import { useState } from 'react';
import { Props as JobCardProps } from '../JobCard';

const JobListWrapper = styled.div<{ isMain: boolean }>`
  width: 100%;
  max-width: 1080px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin: 0 auto;

  ${(props) =>
    !props.isMain &&
    `
    padding-top: 80px;
  `}
`;

const JobListContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
`;

const JobListTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  cursor: pointer;
`;

const JobListTile = styled.p`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.48px;
`;

const CarerrMoveButtonWrapper = styled.div`
  width: 1080px;
  display: flex;
  justify-content: end;
  padding-top: 20px;
`;

const CarerrMoveButton = styled.p`
  display: inline-flex;
  padding: 13px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  border-radius: 8px;
  background: ${primary.blue};
  color: ${white};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -0.32px;
`;

type Props = {
  readonly isMain?: boolean;
};

// TODO : API로 뺴야합니다.
export const careerList: JobCardProps[] = [
  {
    id: 1,
    categoryId: 0,
    title: 'Front-End 프론트엔드 5년이상 시니어개발자',
    summaryList: ['스틸보소', '정규직', '개발', '판교', '급여 협의'],
    summaryDate: '채용 마감',
  },
  {
    id: 2,
    categoryId: 0,
    title: 'Back-end / Server Engineer 3년이상 주니어개발자',
    summaryList: ['스틸보소', '정규직', '개발', '판교', '급여 협의'],
    summaryDate: '채용 마감',
  },
  {
    id: 3,
    categoryId: 0,
    title: 'Back-end / Server Engineer 7년이상 시니어개발자',
    summaryList: ['스틸보소', '정규직', '개발', '판교', '급여 협의'],
    summaryDate: '채용 마감',
  },
  {
    id: 4,
    categoryId: 0,
    title: 'ML Engineer 3년 이상 10년 이하 개발자',
    summaryList: ['스틸보소', '정규직', '개발', '판교', '급여 협의'],
    summaryDate: '채용 마감',
  },
  {
    id: 5,
    categoryId: 3,
    title: '스틸보소의 영업담당 동료를 찾습니다.',
    summaryList: ['스틸보소', '정규직', '급여 협의'],
    summaryDate: '채용 마감',
  },
];

// TODO : 하드코딩 다 뺴야합니다.
export default function JobList({ isMain = false }: Props) {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState<number>(0);
  const router = useRouter();

  const categoryList: string[] = ['개발', '디자인', '마케팅', '영업', '인사', '재무회계'];
  const categoryCount: number[] = [4, 0, 0, 1, 0, 0];

  return (
    <>
      <JobListWrapper isMain={isMain}>
        <JobListContentWrapper>
          <JobListTitleWrapper>
            <JobListTile>진행중인 공고</JobListTile>
            {isMain && (
              <Image
                src="/assets/images/arrow_black.png"
                alt="arrow_block"
                width={24}
                height={24}
                onClick={() => router.push(COMPANY_HIRE_NOTION_LIST)}
              />
            )}
          </JobListTitleWrapper>
          <SummaryTextList
            summaryList={categoryList.map((category, index) => `${category} ${categoryCount[index]}`)}
            defaultColor={gray.gray6}
            onClick={(index) => categoryCount[index] && setActiveCategoryIndex(index)}
            activeIndex={activeCategoryIndex}
          />
        </JobListContentWrapper>

        <JobCardList careerList={careerList.filter((item) => item.categoryId === activeCategoryIndex)} />

        {!isMain && (
          <CarerrMoveButtonWrapper>
            <CarerrMoveButton onClick={() => router.push(COMPANY_HIRE_NOTION)}>메인으로</CarerrMoveButton>
          </CarerrMoveButtonWrapper>
        )}
      </JobListWrapper>
    </>
  );
}
